import {
  Grid2 as Grid,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Header from "./Header";

export const Contact = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid container m={1} mb={20}>
      <Header />

      <Stack
        display="flex"
        justifyContent="center"
        alignItems="center"
        direction={isMobile ? "column" : "row"}
        width="100%"
        spacing={isMobile ? 4 : 10}
        mt={5}
      >
        <Grid size={6} display="flex" justifyContent="center">
          <Stack
            m={isMobile ? 5 : 10}
            display="flex"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Typography variant={isMobile ? "h4" : "h3"} color="primary">
              Contact Us
            </Typography>
            <Typography variant="h6" color="info">
              We are available 24/7 to take your calls.
            </Typography>

            <Typography mt={2} variant={isMobile ? "h5" : "h4"} color="primary">
              Phone: 503-272-1113
            </Typography>
            <Typography mt={2} variant={isMobile ? "h5" : "h4"} color="primary">
              Email: cody@dryermechanic.com
            </Typography>
          </Stack>
        </Grid>
        <Grid
          size={6}
          display="flex"
          justifyContent="center"
          mt={isMobile ? 5 : 10}
        >
          <img
            src="logo.png"
            alt="dryer"
            style={{ width: isMobile ? "80%" : "60%" }}
          />
        </Grid>
      </Stack>
    </Grid>
  );
};
